import React, { Component, Fragment } from 'react';
import _set from 'lodash/set';
import _get from 'lodash/get';

import FontIcon from 'material-ui/FontIcon';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { red500 } from 'material-ui/styles/colors';
import AutoComplete from 'material-ui/AutoComplete';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

export default class ModalEditRow extends Component {
  state = {
      data: {
          type: [],
          sf: '',
          seaRatesCategories: [],
          cargoMaxVolume: 0,
          cargoMaxWeight: 0,
          ...this.props.data,
      },
      errors: {},
      values: [],
      vesselType: ['bulk', 'bulktank', 'car', 'cont', 'livestock', 'mpp', 'pass', 'passcar', 'reefer', 'tank'],
      searchQuery: '',
      error: '',
  }

  async componentDidMount() {
      const { data, isDialogOpened } = this.props;

      if (isDialogOpened) {
          const res = await api.getOneCargoByRealCargoId(data._id);
          if (res.status === 200) {
              if (!res.data.hasOwnProperty('_id')) {
                  showNotification('Cargo real name does not have assigned cargo names', 'error');
              } else {
                  this.setState({
                      data: {
                          ...this.state.data,
                          type: res.data.vesselTypes,
                          sf: res.data.sf,
                          cargoMaxVolume: res.data.cargoMaxVolume,
                          cargoMaxWeight: res.data.cargoMaxWeight,
                          seaRatesCategories: this.prepareSeaRatesCategories(res.data.seaRatesCategories, 0, this.props.SEARATES_CATEGORIES),
                      },
                  });
              }
          }
      }
  }

  searchCategories = (cats, text, result = [], parentName = '', parentNode = []) => {
      for (const cat of (cats || [])) {
          if (~cat.title.toLowerCase().trim().indexOf(text.toLowerCase().trim())) {
              result.push({
                  title: `${parentName ? parentName + ' / ' : ''}${cat.title}`,
                  value: parentNode.concat([cat]),
              });
          }
          if (cat.childCategories && cat.childCategories.length) {
              const res = this.searchCategories(cat.childCategories, text, result, `${parentName ? parentName + ' / ' : ''}${cat.title}`, parentNode.concat([cat]));
              result.concat(res);
          }
      }
      return result;
  }

  prepareSeaRatesCategories = (cats = [], i = 0, constCategories = [], result = []) => {
      if (!cats.length || i === cats.length) {
          return result;
      }

      const finded = constCategories.find(c => c.id === cats[i].id);
      return !finded ? result : this.prepareSeaRatesCategories(cats, ++i, finded.childCategories || [], result.concat([finded]));
  }

  handleChange = (key = 'type', value) => this.setState({
      data: {
          ...this.state.data,
          [key]: value,
      },
      errors: {},
      error: '',
  });

  handleSearch = (value) => {
      this.setState({ searchQuery: value });
  }

  handleChangeNumber = (key = 'sf', value = '') => {
      let dots = 0;
      value = value
          .replace(/[^\d|\.|-]/, '')
          .replace(/\./g, () => (dots++ > 0 ? '' : '.'))
          .replace(/\-/g, (match, str) => (str === 0 ? '-' : ''));

      this.setState({
          data: {
              ...this.state.data,
              [key]: value,
          },
          errors: {
              ...this.state.errors,
              [key]: value && !isNaN(parseFloat(value)) ? '' : 'required',
          },
          error: '',
      });
  }

  renderCategiryPicker = () => {
      const { data: { seaRatesCategories = [] } } = this.state;
      return seaRatesCategories.map((cat, i) => cat.childCategories && (
          <Fragment>
              <SelectField
                  key={`add-cat-${cat.id}`}
                  hintText="Select category"
                  floatingLabelText="Select category"
                  value={seaRatesCategories[i + 1] || {}}
                  onChange={(event, index, value) => {
                      this.handleChange('seaRatesCategories', seaRatesCategories.slice(0, i + 1).concat([value]));
                  }}
                  fullWidth
              >
                  {
                      cat.childCategories.map(catChild => (
                          <MenuItem
                              key={catChild.id}
                              value={catChild}
                              primaryText={catChild.title}
                          />
                      ))
                  }
              </SelectField>
              {
                  seaRatesCategories[i + 1] &&
                  <div
                      className='text-click-remove'
                      onClick={() => this.handleChange('seaRatesCategories', seaRatesCategories.slice(0, i + 1))}
                  >
                      {seaRatesCategories[i + 1].title}
                      <FontIcon className="material-icons" color={red500}>close</FontIcon>
                  </div>
              }
          </Fragment>
      ));
  }

  submit = async () => {
      const {
          data: {
              type = [], sf = '', seaRatesCategories = [], cargoMaxVolume = '', cargoMaxWeight = '', 
          }, errors, 
      } = this.state;
      const { data: item } = this.props;

      if (
          Object.keys(errors).reduce((res, key) => (errors[key] ? true : res), false)
      ) {
          return showNotification('There is an error. Check out inputs', 'error');
      }

      const data = {
          vesselTypes: type,
          sf: +sf || 0,
          cargoMaxVolume: +cargoMaxVolume || 0,
          cargoMaxWeight: +cargoMaxWeight || 0,
          seaRatesCategories: seaRatesCategories.map(c => ({ title: c.title, id: c.id })),
      };

      const result = await api.updateRealAdditionalInfo(item._id, data);

      if (result.status === 200) {
          showNotification('Success');
          return this.props.toggleDialog();
      }

      this.setState({ ...getNormalErrors(result) });
      showNotification(this.state.error, 'error');
  }

  render() {
      const { toggleDialog, isDialogOpened, SEARATES_CATEGORIES = [] } = this.props;
      const {
          data: {
              type = [],
              sf = '',
              seaRatesCategories = [],
              cargoMaxVolume = 0,
              cargoMaxWeight = 0,
          },
          error,
          errors,
          vesselType,
          searchQuery,
      } = this.state;
      const searatesSearchCategories = searchQuery.length > 2 ? this.searchCategories(SEARATES_CATEGORIES, searchQuery) : [];
	  console.log(this.state);
      return (
          <Dialog
              title='Edit'
              actions={[
                  <FlatButton
                      key={'FlatButton' + 1}
                      label='Ok'
                      primary
                      onClick={this.submit}
                  />,
                  <FlatButton
                      key={'FlatButton' + 2}
                      label='Cancel'
                      primary
                      onClick={toggleDialog}
                  />,
              ]}
              open={isDialogOpened}
              contentStyle={{
                  width: '80%',
              }}
              autoScrollBodyContent
              modal
          >
              <h4 className='m-b-0'>Choose vessel types</h4>
              <SelectField
                  multiple
                  hintText="Select vessel type"
                  value={type}
                  onChange={(event, index, values) => this.handleChange('type', values)}
                  fullWidth
              >
                  {
                      vesselType.map(name => (
                          <MenuItem
                              key={name}
                              insetChildren
                              checked={type && type.indexOf(name) > -1}
                              value={name}
                              primaryText={name}
                          />
                      ))
                  }
              </SelectField>
              <div>
                  {`Vessel type: ${type.length ? type.join(', ') : 'None'}`}
              </div>
              <h4 className='m-b-0'>SF</h4>
              <TextField
                  value={sf}
                  hintText='SF'
                  onChange={(e, value) => this.handleChangeNumber('sf', value)}
                  fullWidth
                  errorText={errors.sf}
              />
              <h4 className='m-b-0'>Search Searates categories</h4>
              <AutoComplete
                  hintText="Name"
                  floatingLabelText="Name"
                  dataSource={searatesSearchCategories}
                  dataSourceConfig={{ text: 'title', value: 'value' }}
                  onUpdateInput={value => this.handleSearch(value)}
                  onNewRequest={selected => this.handleChange('seaRatesCategories', selected.value)}
                  fullWidth
                  filter={AutoComplete.noFilter}
                  menuStyle={{ maxHeight: '300px', overflowY: 'auto' }}
              />
              <h4 className='m-b-0'>Searates categories</h4>
              <SelectField
                  key="SelectField-categories"
                  hintText="Select category"
                  floatingLabelText="Select category"
                  value={seaRatesCategories && seaRatesCategories[0] || {}}
                  onChange={(event, index, value) => this.handleChange('seaRatesCategories', [value])}
                  fullWidth
              >
                  {
                      SEARATES_CATEGORIES.map(cat => (
                          <MenuItem
                              key={cat.id}
                              value={cat}
                              primaryText={cat.title}
                          />
                      ))
                  }
              </SelectField>
              {
                  seaRatesCategories && seaRatesCategories[0] &&
                  <div
                      className='text-click-remove'
                      onClick={() => this.handleChange('seaRatesCategories', [])}
                  >
                      {seaRatesCategories[0].title}
                      <FontIcon className="material-icons" color={red500}>close</FontIcon>
                  </div>
              }
              {this.renderCategiryPicker()}
              <h4 className='m-b-0'>Max weight (t)</h4>
              <TextField
                  value={cargoMaxWeight}
                  hintText='Cargo max weight'
                  onChange={(e, value) => this.handleChangeNumber('cargoMaxWeight', value)}
                  fullWidth
                  errorText={errors.cargoMaxWeight}
              />
              <h4 className='m-b-0'>Max volume (m^3)</h4>
              <TextField
                  value={cargoMaxVolume}
                  hintText='Cargo max volume'
                  onChange={(e, value) => this.handleChangeNumber('cargoMaxVolume', value)}
                  fullWidth
                  errorText={errors.cargoMaxVolume}
              />
              {
                  error &&
                  <div className='error'>{error}</div>
              }
          </Dialog>
      );
  }
}



// WEBPACK FOOTER //
// ./app/components/Cargoes/RealNames/ModalEditRow.js